import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ContentContext = createContext({ content: {}, isAdmin: false, save: async () => {} });

export const useContent = () => useContext(ContentContext);

export function ContentProvider({ children }) {
  const { user } = useAuth();
  const [content, setContent] = useState({});

  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data || {})).catch(() => {});
  }, []);

  const isAdmin = user?.role === "admin";

  const save = async (key, value) => {
    await api.put(`/admin/content/${key}`, { value });
    setContent((c) => ({ ...c, [key]: value }));
  };

  return (
    <ContentContext.Provider value={{ content, isAdmin, save }}>
      {children}
    </ContentContext.Provider>
  );
}
